var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKey5 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H7.465a4 4 0 1 0 0 4H8l1-1h1v1h1l1-1h1v1h1l2-2zM3 9.414a1.414 1.414 0 1 1 0-2.828 1.414 1.414 0 0 1 0 2.828M8 7.5V7h6l.25.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKey5);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/key5.svg";